import * as Models from "../../../Models";
import * as Services from "../../../Services";
import * as toastr from "toastr";
import * as _ from "lodash";
    export interface IAssignUtilityModalScope extends ng.IScope {
        assignUtilityModalCtrl: AssignUtilityModalCtrl;
    }

    export class AssignUtilityModalCtrl {
        associateRegionRequest: Models.Customer.AssociateRegionToCustomerRequest.IAssociateRegionToCustomerRequest;

        utilitiesInCustomersTerritory: Models.CostCalculation.Utility.IUtility[];
        regionsInSelectedUtility: Models.CostCalculation.Region.IRegion[];

        public static $inject = ['$scope', '$modalInstance', 'CustomerApiClient', 'PricingApiClient', 'customerDetails', 'partnerNumber', 'leadNumber'];
        constructor(
            public $scope: IAssignUtilityModalScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
            public pricingApiClient: Services.PricingApiClient.IPricingApiClient,
            public customerDetails: Models.Customer.SolarCustomerDetailsResponse.ISolarCustomerDetailsResponse,
            public partnerNumber: string,
            public leadNumber: string) {

            $scope.assignUtilityModalCtrl = this;

            this.associateRegionRequest = new Models.Customer.AssociateRegionToCustomerRequest.AssociateRegionToCustomerRequest();
            this.associateRegionRequest.partnerNumber = partnerNumber;
            this.associateRegionRequest.leadNumber = leadNumber;

            this.loadActiveUtilitiesInCustomersRegion(partnerNumber, leadNumber);
        }

        public sendAssociateRegionToCustomerRequest = (): void => {
            this.customerApiClient.associateRegionToCustomer(this.associateRegionRequest)
                .then((response: Models.Customer.AssociateRegionToCustomerResponse.IAssociateRegionToCustomerResponse) => {
                    if (response.success) {
                        this.$modalInstance.close(response);
                    } else if (response.errors.length > 0) {
                        response.errors.forEach(error => toastr.error(error));
                    } else {
                        toastr.error('Internal Server Error. Please try again later.');
                    }
                });
        }

        public onSelectedTerritoryChange = (): void => {
            var selectedUtility = _.find(this.utilitiesInCustomersTerritory, u => u.utilityId === this.associateRegionRequest.utilityId);
            this.regionsInSelectedUtility = selectedUtility.regions;
        }

        public dismissModal = (): void => {
            this.$modalInstance.dismiss();
        }

        private loadActiveUtilitiesInCustomersRegion = (partnerNumber: string, leadNumber: string): void => {

            this.customerApiClient.getCustomerTerritory(null, partnerNumber, leadNumber)
                .then((territory: Models.CostCalculation.Territory.ITerritory) => {
                    return this.pricingApiClient.getActiveUtilitiesAvailableToAssignToCustomer(territory.territoryId, partnerNumber, leadNumber);
                })
                .then((utilities: Models.CostCalculation.Utility.IUtility[]) => {
                    this.utilitiesInCustomersTerritory = utilities;
                });
        }

    }
